import { Container, Texture } from '../../../odie';

import { AndroidBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const styles = [
  {
    asset: 'android/block.android.0.png',
    x: 75,
    y: 72,
  },
  {
    asset: 'android/block.android.1.png',
    x: 75,
    y: 72,
  },
  {
    asset: 'android/block.android.2.png',
    x: 75,
    y: 72,
  },
];

/*
    android block view
*/
export class AndroidBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _sprite: FitWidthBlockSprite;
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    const style = styles[value];

    // update field
    this._count = value;

    // update view texture based on count
    this._sprite.texture = Texture.from(style.asset);

    // position view based on count
    this.x = style.x;
    this.y = style.y;
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: AndroidBlockProps) {
    // create base view
    super();
    this._sprite = new FitWidthBlockSprite(styles[0].asset, props);
    this._sprite.scaleX = this._sprite.scaleY = 0.6;
    this._sprite.y = 3;
    this.addChild(this._sprite);
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return styles.map((style) => style.asset);
  }
}
